<template>
  <div id="app">
    <template v-if="$route.matched.length">
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@import "@/styles/tokens.scss";

#app {
  font-family: Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: var(--ink);
  margin: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100vh;
}
body {
  margin: 0;
  padding: 0;
  background: var(--navy);
}

// Import Font Awesome 5 Free
$fa-css-prefix: "el-icon-fa";
$fa-font-path: "~@fortawesome/fontawesome-free/webfonts";

@import "~@fortawesome/fontawesome-free/scss/fontawesome.scss";
@import "~@fortawesome/fontawesome-free/scss/regular.scss";
@import "~@fortawesome/fontawesome-free/scss/solid.scss";
@import "~@fortawesome/fontawesome-free/scss/brands.scss";

// Override Element UI's icon font
.fas {
  font-family: "Font Awesome 5 Free" !important;
}

.fab {
  font-family: "Font Awesome 5 Brands" !important;
}
</style>
